'use client'

import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { ProductFlag } from '../../ProductFlag'
import { useProductVolumePricingContext } from '../ProductVolumePricingContext'
import { ProductVolumePricingModal } from '../ProductVolumePricingModal'

type VolumePricingBadgeProps = {
  className?: string
  discount?: number
  discountActivated?: boolean
  quantity?: number
}

export const ProductVolumePricingBadge: FC<VolumePricingBadgeProps> = ({
  className,
  discount,
  discountActivated,
  quantity,
}) => {
  const { openableControls } = useProductVolumePricingContext()

  if (!discount || !quantity) {
    return null
  }

  return (
    <>
      <ProductVolumePricingModal />
      <ProductFlag
        className={clsx('w-fit', className)}
        onClick={openableControls.handleOpen}
      >
        {discountActivated ? (
          <FormattedMessage
            id="volumePricing.pdp.label.maxDiscount.text"
            values={{
              discount,
            }}
          />
        ) : (
          <FormattedMessage
            id="volumePricing.pdp.label.text"
            values={{
              discount,
              quantity,
            }}
          />
        )}
      </ProductFlag>
    </>
  )
}
